import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/en/services/pharmacovigilance/safety-database-solution")({
  head: () => buildRouteHead("/en/services/pharmacovigilance/safety-database-solution"),
  component: PVOffering,
});

